<template>
  <div id="contenedor-presupuesto-detalle-picker">
    <v-autocomplete
      v-model="presupuestoDetallesSeleccionados"
      :label="getLabel"
      :items="getPresupuestos"
      return-object
      :multiple="multiSelect"
      filled
      clearable
      :disabled="isDisabled"
      color="#6A83B5"
      background-color="#F2F6FF"
      item-text="claveObra"
      :filter="filtro"
      @change="enviarSeleccionados">
      <template
        v-slot:item="data">
        <v-list-item-avatar>
          <v-avatar
            size="24"
            :color="data.item.color">
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ data.item.claveObra }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ data.item.importe | currency }} - {{data.item.obra.meta.slice(0,100)}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import PRESUPUESTOS from '@/graphql/querys/administracion/presupuestos/presupuestos.gql';

export default {
  name: 'PresupuestoDetallePicker',
  props: {
    multiSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    idObra: {
      type: String,
      required: false,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      presupuestoDetallesSeleccionados: [],
      search: '',
    };
  },
  methods: {
    filtro(item, queryText) {
      const clave = item.claveObra.toLowerCase();
      const meta = item.obra.meta.toLowerCase();

      const expt = new RegExp(queryText, 'gi');

      return expt.test(clave) || expt.test(meta);
    },
    enviarSeleccionados() {
      // V-MODEL
      this.$emit('inputPresupuestoDetalle', this.presupuestoDetallesSeleccionados);
      // ENVIAR SOLO IDS SELECCIONADOS
      if (this.multiSelect === true) {
        this.$emit('solo-idsPresupuestoDetalle', this.presupuestoDetallesSeleccionados.map((detalle) => detalle.id));
      } else if (this.presupuestoDetallesSeleccionados !== null) {
        this.$emit('solo-idsPresupuestoDetalle', [this.presupuestoDetallesSeleccionados.id]);
      } else {
        this.$emit('solo-idsPresupuestoDetalle', []);
      }
    },
  },
  apollo: {
    presupuestos: {
      query: PRESUPUESTOS,
    },
  },
  computed: {
    getLabel() {
      if (this.multiSelect === true) return 'Seleccionar recursos presupuestdos';
      return 'Seleccionar recurso presupuestado';
    },
    getPresupuestos() {
      const detalles = [];
      if (!this.presupuestos) return [];
      if (this.idObra === '') {
        this.presupuestos
          .forEach((presupuesto) => {
            detalles.push(presupuesto.detalles
              .map((d) => ({ ...d, color: '#6A83B5' })));
          });
        return detalles.flat(1);
      }

      this.presupuestos
        .forEach((presupuesto) => {
          detalles.push(presupuesto.detalles
            .filter((d) => d.idObra === this.idObra)
            .map((d) => ({ ...d, color: '#6A83B5' })));
        });
      return detalles.flat(1);
    },
  },
  watch: {
    presupuestoDetallesSeleccionados() {
      this.search = '';
    },
  },
};
</script>

<style lang="scss">

</style>
